export default __webpack_public_path__ + "assets/a41fb3aa5275e666bb4512431283feb7.jpg";